export default __webpack_public_path__ + "static/media/clear-tiny.36aae039.svg";